import React from 'react';
import { Button } from '@/components/ui/button';
import { ExportButton } from '@/shared/ui/export/ExportButton';
import { Plus, Filter } from 'lucide-react';

export interface PaymentScreenHeaderProps {
  showFilters: boolean;
  onToggleFilters: () => void;
  onExport: () => void;
  isExporting: boolean;
  onOpenAddPayment: () => void;
}

export const PaymentScreenHeader: React.FC<PaymentScreenHeaderProps> = ({
  showFilters,
  onToggleFilters,
  onExport,
  isExporting,
  onOpenAddPayment,
}) => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Payments</h1>
        <p className="text-gray-600 mt-1">Manage influencer payments and invoices</p>
      </div>
      <div className="flex items-center space-x-3">
        <Button variant="outline" onClick={onToggleFilters}>
          <Filter className="w-4 h-4 mr-2" />
          Filters
        </Button>
        <ExportButton
          variant="outline"
          iconType="download"
          isLoading={isExporting}
          loadingLabel="Exporting..."
          onClick={onExport}
        />
        <Button onClick={onOpenAddPayment}>
          <Plus className="w-4 h-4 mr-2" />
          Add Payment
        </Button>
      </div>
    </div>
  );
};
